import { useMutation } from '@tanstack/react-query'
import { markWebTicketRead } from '../index'

const useMarkWebTicketRead = () =>
  useMutation({
    mutationFn: markWebTicketRead,
  })

export default useMarkWebTicketRead
